import styled from 'styled-components';
import { mediaQueries } from '../shared/config';
import { useMediaQuery } from 'react-responsive';

const Card = styled.div`
    width: 100%;
    height: 30vh;
    background: linear-gradient(${props => props.position === "left" ? 90 : 270}deg, ${props => props.color} 60%, rgba(198, 188, 171, 0.9) 30%);
    // border: 3px solid #000000;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;

    ${mediaQueries.mobile} {
        width: 100%;
        height: 18vh;
        border: 1px solid black;
        line-height: 20vh;
        box-sizing: border-box; // Include the padding and border in the width of the element
    }
`
const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    ${mediaQueries.mobile} {
        justify-content: flex-start; // Align items at the start on mobile
        padding-top: 1vh; // Adjust padding to move content up
    }
`;

const Title = styled.div`
    width: 22vw;
    height: fit-content;
    font-family: "Oswald", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 2.8vh;
    text-align: left;
    line-height: 35.05px;
    color: black;
    align-items: center;
    margin-left: ${props => props.position === "left" ? 1 : 16}em;

    ${mediaQueries.mobile} {
        width: 13em;
        height: 4em;
        font-size: 13px;
        line-height: 17px;
            padding-bottom: 2vh;
        margin-left: ${props => props.position === "left" ? 1 : 16}em;
        margin-top: 0.5em; // Adjust margin-top for mobile
    }
`
const ByLine = styled.div`
    width: 22vw;
    height: fit-content;
    font-family: "Oswald", sans-serif;
    font-weight: 400;
    font-size: 2.8vh;
    line-height: 35.05px;
    color: black;
    text-align: left;
    align-items: center;
    padding-bottom: 0.5vh;
    margin-left: ${props => props.position === "left" ? 1.75 : 26}vw;

    ${mediaQueries.mobile} {
        width: 13em;
        height: 4em;
        font-size: 10px;
        padding-bottom: 5vh;
        margin-left: ${props => props.position === "left" ? -2.4 : 17.4}em;
        line-height: 15px;
        margin-top: 0; // Remove margin-top for mobile
    }
`

const Image = styled.img`
    width: 62.5%;
    height: 29.52vh;
    object-fit: cover;
    border: 2px 2px 2px 0px;
    position: absolute;
    top: 0vh; 
    left: ${props => props.position === "left" ? 18.75: -0.25}vw;
    mask-image: linear-gradient(${props => props.position === "left" ? "to right" : "to left"}, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 1) 30%);

    ${mediaQueries.mobile} {
        width: 65vw;
        height: 18vh;
        object-fit: cover;
        left: ${props => props.position === "left" ? 9 : -2}em;
    }
`

const ArticleCard = (props) => {
    return (
        <>  
            <a href={props.article_url} style={{ textDecoration: 'none', color: 'inherit' }}>
                <Card color={props.color} position={props.position}>
                    <Container>
                        <Title position={props.position}>{props.article_title}</Title>
                        <ByLine position={props.position}>by {props.article_byline}</ByLine>
                    </Container>
                    <Image position={props.position} src={props.article_image} alt="Article image"/>
                </Card>
            </a>
        </>
    )
}

export default ArticleCard;
